import { render, staticRenderFns } from "./submitted-modal.vue?vue&type=template&id=62f79a86"
import script from "./submitted-modal.vue?vue&type=script&lang=js"
export * from "./submitted-modal.vue?vue&type=script&lang=js"
import style0 from "./submitted-modal.vue?vue&type=style&index=0&id=62f79a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports